import Russian from './Russian';

export default Russian;
